import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    extendedStyles?: OutOfMarketNoticeStyles;
}

type Props = OwnProps;

export interface OutOfMarketNoticeStyles {
    label?: TypographyProps;
}

export const OutOfMarketNoticeStyles: OutOfMarketNoticeStyles = {};

const OutOfMarketNotice: FC<Props> = ({ product, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(OutOfMarketNoticeStyles, extendedStyles));

    let message = "";
    let isDrawing = false;
    if ("product" in product) {
        message = product.product.properties.isOutOfMarketMessage;
        if (product.product.properties?.isDrawing && product.product.properties?.isDrawing?.toLowerCase() === "true") {
            isDrawing = true;
        }
    }
    if (message === "" || isDrawing) {
        return null;
    }
    return <Typography {...styles.label}>{message}</Typography>;
};

export default OutOfMarketNotice;
